"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getRelatedPosts;
const utils_1 = require("@pulsex/utils");
const client_1 = __importDefault(require("../../client/client"));
function getRelatedPosts({ config, postId, timezoneOffset, fromDate, toDate, size = 4, }) {
    if (!postId)
        return;
    if (!config["SEARCH_URL"])
        throw new Error("SEARCH_URL is not defined in config");
    // Default toDate to now if not provided
    const effectiveToDate = toDate !== null && toDate !== void 0 ? toDate : new Date();
    const params = {
        id: postId,
    };
    const body = {
        userId: config["CLIENT_ID"],
        fromDate: (0, utils_1.convertToClientTimeZone)({
            date: fromDate, // fromDate is already a string?
            timezone: timezoneOffset,
        }),
        toDate: (0, utils_1.convertToClientTimeZone)({
            date: effectiveToDate,
            timezone: timezoneOffset,
        }),
        size,
    };
    return client_1.default.post(config["SEARCH_URL"], "/related", body, params);
}
